"use client"; // Error boundaries must be Client Components

import localFont from "next/font/local";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import "@/theme/topshop/index.css";
import { useEffect } from "react";
import { VisuallyHidden } from "@repo/ui/visually-hidden";
import { Logo } from "@/components/logo";
import { STRINGS } from "@/constants";
import {
  TYPOGRAPHY_BODY3_SENTENCE,
  TYPOGRAPHY_DISPLAY1,
} from "@/theme/topshop/typography/typography-constants";
import fatalImage from "../public/fatal-background.png";

import classes from "./global-error.module.css";

const relativePro = localFont({
  src: [
    {
      path: "../theme/fonts/Relative-Black-Pro.woff2",
      weight: "900",
    },
    {
      path: "../theme/fonts/Relative-Bold-Pro.woff2",
      weight: "700",
    },
    {
      path: "../theme/fonts/Relative-Book-Pro.woff2",
      weight: "400",
    },
  ],
  variable: "--font-family-relative-pro",
});

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const router = useRouter();

  useEffect(() => {
    console.error("Global Error:", error);
    if (error.digest) {
      console.error("Error Digest:", error.digest);
    }
  }, [error]);

  const onClick = () => {
    router.refresh();
  };

  return (
    <html lang="en" className={relativePro.variable}>
      <body>
        <div className={classes.bgImg}>
          <Image
            alt=""
            src={fatalImage}
            placeholder="blur"
            quality={100}
            fill
            sizes="100vw"
            style={{
              objectFit: "cover",
            }}
          />
        </div>
        <nav className={classes.nav}>
          <Link href="/">
            <Logo variant="topshop" className={classes.logo} />
            <VisuallyHidden>{STRINGS.errors.brandName}</VisuallyHidden>
          </Link>
        </nav>
        <main className={classes.main}>
          <h1 className={`${TYPOGRAPHY_DISPLAY1} ${classes.title}`}>
            {STRINGS.errors.maintenance.title}
          </h1>
          <p className={`${TYPOGRAPHY_BODY3_SENTENCE} ${classes.description}`}>
            {STRINGS.errors.maintenance.message}
          </p>
          <button onClick={onClick} className={classes.button}>
            {STRINGS.errors.maintenance.refresh}
          </button>
        </main>
      </body>
    </html>
  );
}
